import { Link } from "react-router-dom";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function NotFound() {
  useDocumentMeta({
    title: "页面不存在 - 新金瓶梅",
    description: "抱歉，你访问的页面不存在或已被移除，返回首页继续浏览影视资讯与剧情介绍。",
  });

  return (
    <div className="page-shell flex min-h-[70vh] flex-col items-center justify-center pt-24 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-3xl text-foreground-400">
        <i className="ri-compass-3-line" aria-hidden="true"></i>
      </span>
      <p className="mt-6 font-heading text-5xl font-extrabold text-primary-500 md:text-7xl">404</p>
      <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        页面不存在
      </h1>
      <p className="mt-3 max-w-md text-sm text-foreground-500">
        你访问的页面可能已被移除或链接有误，不妨回到首页，继续探索新的影视资讯与剧情介绍。
      </p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" aria-hidden="true"></i>
          返回首页
        </Link>
        <Link
          to="/category/movies"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          <i className="ri-movie-2-line" aria-hidden="true"></i>
          浏览电影频道
        </Link>
      </div>
    </div>
  );
}